var _style, _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _text, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoAidotec(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 960 322",
    style: {
      enableBackground: "new 0 0 960 322"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#2EA58D;}\r\n\t.st2{fill:#3FA0CC;}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#2EA58D;}\r\n\t.st4{fill:none;}\r\n\t.st5{display:none;fill:#2EA58D;}\r\n\t.st6{font-family:'WhisperQuiet';}\r\n\t.st7{font-size:33px;}\r\n\t.st8{fill:#2EA58D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M567.2,274.7v3.2h-7.6v15.9h7.6v3.2h-11.4v-22.2H567.2z M565.6,287.4H561l-1.4-3.2h6V287.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M915.2,274.7v3.2h-7.6v15.9h7.6v3.2h-11.4v-22.2H915.2z M913.6,287.4H909l-1.4-3.2h6V287.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M533,290.7v-16.1h3.8v16.1c0,4.2-2.1,6.3-6.3,6.3s-6.3-2.1-6.3-6.3v-16.1h3.8v16.1c0,2.1,0.8,3.2,2.5,3.2 S533,292.8,533,290.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M543.7,283.9v12.9h-3.8v-22.2h3.8l5,12.9v-12.9h3.8v22.2h-3.8L543.7,283.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M581.4,274.3c4.2,0,6.3,2.1,6.3,6.3v10.1c0,4.2-2.1,6.3-6.3,6.3s-6.3-2.1-6.3-6.3v-10.1 C575.1,276.4,577.2,274.3,581.4,274.3z M583.9,280.6c0-2.1-0.8-3.2-2.5-3.2s-2.5,1.1-2.5,3.2v10.1c0,2.1,0.8,3.2,2.5,3.2 s2.5-1.1,2.5-3.2V280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M630.4,293.6h-3.7l-0.7-1.9l-1.2,5H621l5.1-22.2h3.8l5.1,22.2h-3.8L630.4,293.6z M626.2,290.4h3.5l-1.7-7.5 L626.2,290.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M649.1,280.6l-3.8,1.6v-1.6c0-2.1-0.8-3.2-2.5-3.2s-2.5,1.1-2.5,3.2c0,1.8,1.5,3.1,4.4,3.9 c3,0.8,4.4,2.9,4.4,6.3c0,4.2-2.1,6.3-6.3,6.3s-6.3-2.1-6.3-6.3l3.8-1.6v1.6c0,2.1,0.8,3.2,2.5,3.2s2.5-1.1,2.5-3.2 c0-1.8-1.5-3.1-4.4-3.9c-3-0.8-4.4-2.9-4.4-6.3c0-4.2,2.1-6.3,6.3-6.3S649.1,276.4,649.1,280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M656.1,296.8h-3.8v-22.2h3.8V296.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M665.6,274.3c4.2,0,6.3,2.1,6.3,6.3v10.1c0,4.2-2.1,6.3-6.3,6.3s-6.3-2.1-6.3-6.3v-10.1 C659.3,276.4,661.4,274.3,665.6,274.3z M668.1,280.6c0-2.1-0.8-3.2-2.5-3.2s-2.5,1.1-2.5,3.2v10.1c0,2.1,0.8,3.2,2.5,3.2 s2.5-1.1,2.5-3.2V280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M678.9,283.9v12.9h-3.8v-22.2h3.8l5,12.9v-12.9h3.8v22.2h-3.8L678.9,283.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M699.5,284.1v12.7h-3.8v-22.2h6.3c4.2,0,6.3,2.1,6.3,6.3c0,4.2-2.1,6.3-6.3,6.3h-1.3L699.5,284.1z  M699.5,284.1h2.5c1.7,0,2.5-1.1,2.5-3.2c0-2.1-0.8-3.2-2.5-3.2h-2.5V284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M717.8,274.3c4.2,0,6.3,2.1,6.3,6.3v10.1c0,4.2-2.1,6.3-6.3,6.3s-6.3-2.1-6.3-6.3v-10.1 C711.5,276.4,713.6,274.3,717.8,274.3z M720.4,280.6c0-2.1-0.8-3.2-2.5-3.2s-2.5,1.1-2.5,3.2v10.1c0,2.1,0.8,3.2,2.5,3.2 s2.5-1.1,2.5-3.2V280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M736.2,290.7v-16.1h3.8v16.1c0,4.2-2.1,6.3-6.3,6.3s-6.3-2.1-6.3-6.3v-16.1h3.8v16.1c0,2.1,0.8,3.2,2.5,3.2 S736.2,292.8,736.2,290.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M746.9,284.1v12.7h-3.8v-22.2h6.3c4.2,0,6.3,2.1,6.3,6.3c0,2.1-0.5,3.7-1.6,4.7c1.1,1.1,1.6,2.6,1.6,4.7v6.3 H752v-6.3c0-2.1-0.8-3.2-2.5-3.2h-1.3L746.9,284.1z M746.9,284.1h2.5c1.7,0,2.5-1.1,2.5-3.2c0-2.1-0.8-3.2-2.5-3.2h-2.5V284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M767.5,296.8h-3.8v-22.2h3.8V296.8z M775.1,296.8h-6.3l-1.3-3.2h7.6V296.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M782.1,282.5h-3.8v-7.9h3.8V282.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M793.8,293.6h-3.7l-0.7-1.9l-1.2,5h-3.8l5.1-22.2h3.8l5.1,22.2h-3.8L793.8,293.6z M789.7,290.4h3.5l-1.7-7.5 L789.7,290.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M809.6,290.7v-16.1h3.8v16.1c0,4.2-2.1,6.3-6.3,6.3s-6.3-2.1-6.3-6.3v-16.1h3.8v16.1c0,2.1,0.8,3.2,2.5,3.2 S809.6,292.8,809.6,290.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M824.8,277.8v19l-3.8,0v-19h-4.4v-3.2h12.7v3.2H824.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M837.1,274.3c4.2,0,6.3,2.1,6.3,6.3v10.1c0,4.2-2.1,6.3-6.3,6.3s-6.3-2.1-6.3-6.3v-10.1 C830.8,276.4,832.9,274.3,837.1,274.3z M839.7,280.6c0-2.1-0.8-3.2-2.5-3.2s-2.5,1.1-2.5,3.2v10.1c0,2.1,0.8,3.2,2.5,3.2 s2.5-1.1,2.5-3.2V280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M850.4,283.9v12.9h-3.8v-22.2h3.8l5,12.9v-12.9h3.8v22.2h-3.8L850.4,283.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M868.8,274.3c4.2,0,6.3,2.1,6.3,6.3v10.1c0,4.2-2.1,6.3-6.3,6.3s-6.3-2.1-6.3-6.3v-10.1 C862.5,276.4,864.6,274.3,868.8,274.3z M871.3,280.6c0-2.1-0.8-3.2-2.5-3.2s-2.5,1.1-2.5,3.2v10.1c0,2.1,0.8,3.2,2.5,3.2 s2.5-1.1,2.5-3.2V280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M882.1,283.9v12.9h-3.8v-22.2h3.8l3.8,9.6l3.8-9.6h3.8v22.2h-3.8v-12.9l-3.8,9.7L882.1,283.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M900.4,296.8h-3.8v-22.2h3.8V296.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M603.3,281.6v-1c0-4.3-2.1-6.4-6.4-6.4c-4.3,0-6.4,2.1-6.4,6.4v10.2c0,4.3,2.1,6.4,6.4,6.4 c4.3,0,6.4-2.1,6.4-6.4h0v-1l-3.8-0.6l0,0v1.6c0,2.1-0.9,3.2-2.6,3.2s-2.6-1.1-2.6-3.2v-10.2c0-2.1,0.9-3.2,2.6-3.2 s2.6,1.1,2.6,3.2v1.6L603.3,281.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M619.1,281.6v-1c0-4.3-2.1-6.4-6.4-6.4s-6.4,2.1-6.4,6.4v10.2c0,4.3,2.1,6.4,6.4,6.4c4.3,0,6.4-2.1,6.4-6.4 l0,0v-1l-3.8-0.6l0,0v1.6c0,2.1-0.9,3.2-2.6,3.2s-2.6-1.1-2.6-3.2v-10.2c0-2.1,0.9-3.2,2.6-3.2s2.6,1.1,2.6,3.2v1.6L619.1,281.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Roue"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M179,173.4c0-25.4-13.7-47.5-34-59.6l4.3,9.8l-11,4.9c14.8,9.4,24.6,26,24.6,44.8c0,15.7-6.8,29.7-17.6,39.5 l-8.1-11.6l-2.8,15.9l-2.8,15.9l15.8,3l15.8,3l-8.9-12.8C169.6,213.4,179,194.5,179,173.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M128.2,235.2l2.2-12.8c-6.3,2.6-13.3,4.1-20.5,4.1c-24.8,0-45.6-16.9-51.4-39.9l14.1,0.5l-11-11.7l-11-11.7 l-11.9,10.9l-11.9,10.9l15.2,0.6c5.9,32.2,34.1,56.6,68,56.6c9.7,0,19-2,27.4-5.6L128.2,235.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M139,107.6l-6.4-14.8l-5.2,13.6c-5.6-1.5-11.4-2.2-17.5-2.2c-35.7,0-65.1,27-68.8,61.7l9.8-7.5l6.4,8.1 c3.3-26.1,25.6-46.3,52.7-46.3c4,0,7.9,0.4,11.6,1.3l-5.4,14.1l14.7-6.6l14.7-6.6L139,107.6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Croix"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M137.7,161.6c0,0-8.8,0-11.4,0c-3.1,0-2.9-4-2.9-4v-10.3c0-2.1-1.7-3.7-3.7-3.7H99c-2.1,0-3.7,1.7-3.7,3.7 v10.3c0,0,0.5,4-3.5,4c-2.5,0-10.9,0-10.9,0c-2.1,0-3.7,1.7-3.7,3.7v20.6c0,2.1,1.7,3.7,3.7,3.7c0,0,9.4,0,12.5,0 c2.1,0,1.9,1.7,1.9,1.7V204c0,2.1,1.7,3.7,3.7,3.7h20.6c2.1,0,3.7-1.7,3.7-3.7v-12.5c0,0-0.3-1.8,2-1.8c3.1,0,12.4,0,12.4,0 c2.1,0,3.7-1.7,3.7-3.7v-20.6C141.4,163.2,139.7,161.6,137.7,161.6z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M794.4,147.1v-5.9c0-26.4-13.2-39.6-39.6-39.6s-39.6,13.2-39.6,39.6v63.3c0,26.4,13.2,39.6,39.6,39.6 c26.4,0,39.6-13.2,39.6-39.6h0v-5.9l-23.7-4l0,0v9.9c0,13.2-5.3,19.8-15.8,19.8s-15.8-6.6-15.8-19.8v-63.3 c0-13.2,5.3-19.8,15.8-19.8s15.8,6.6,15.8,19.8v9.9L794.4,147.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M250.8,222.3h-23.1l-4.6-11.7l-7.2,31.5H192l31.7-138.5h23.7L279.1,242h-23.7L250.8,222.3z M224.7,202.5h21.6 l-10.8-47L224.7,202.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M317.6,242h-23.7V103.6h23.7V242z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M361.1,222.3V242h-23.7V103.6H377c26.4,0,39.6,13.2,39.6,39.6v59.3c0,26.4-13.2,39.6-39.6,39.6h-7.9 L361.1,222.3z M361.1,222.3H377c10.5,0,15.8-6.6,15.8-19.8v-59.3c0-13.2-5.3-19.8-15.8-19.8h-15.8V222.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M475.9,101.6c26.4,0,39.6,13.2,39.6,39.6v63.3c0,26.4-13.2,39.6-39.6,39.6s-39.6-13.2-39.6-39.6v-63.3 C436.3,114.8,449.5,101.6,475.9,101.6z M491.7,141.2c0-13.2-5.3-19.8-15.8-19.8s-15.8,6.6-15.8,19.8v63.3c0,13.2,5.3,19.8,15.8,19.8 s15.8-6.6,15.8-19.8V141.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M576.8,123.4v118.7l-23.7,0V123.4h-27.7v-19.8h79.1v19.8H576.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M695.5,103.6v19.8H648v98.9h47.5V242h-71.2V103.6H695.5z M685.3,182.7h-28.5l-8.9-19.8h37.3V182.7z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 426.1,
    y: 274.7,
    className: "st4",
    width: 1006.4,
    height: 159.3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 426.1498 297.222)",
    className: "st5 st6 st7"
  }, "Une occasion pour l&apos;autonomie")), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M46.5,57.1v3.2h-3.9V37.7h6.4c4.3,0,6.4,2.1,6.4,6.4v9.7c0,4.3-2.1,6.4-6.4,6.4h-1.3L46.5,57.1z M46.5,57.1 h2.6c1.7,0,2.6-1.1,2.6-3.2v-9.7c0-2.1-0.9-3.2-2.6-3.2h-2.6V57.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M70.4,37.7v3.2h-7.7v16.1h7.7v3.2H58.8V37.7H70.4z M68.4,50.6h-4.5l-1.3-3.2h5.7V50.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M77.5,47.4v12.9h-3.9V37.7H80c4.3,0,6.4,2.1,6.4,6.4s-2.1,6.4-6.4,6.4h-1.3L77.5,47.4z M77.5,47.4H80 c1.7,0,2.6-1.1,2.6-3.2s-0.9-3.2-2.6-3.2h-2.6V47.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M96.3,57.1h-3.8l-0.8-1.9l-1.2,5.1h-3.9l5.2-22.6h3.9l5.2,22.6h-3.9L96.3,57.1z M92.1,53.8h3.5l-1.8-7.7 L92.1,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M107.2,47.4v12.9h-3.9V37.7h6.4c4.3,0,6.4,2.1,6.4,6.4c0,2.1-0.5,3.8-1.6,4.8c1.1,1.1,1.6,2.7,1.6,4.8v6.4 h-3.9v-6.4c0-2.1-0.9-3.2-2.6-3.2h-1.3L107.2,47.4z M107.2,47.4h2.6c1.7,0,2.6-1.1,2.6-3.2s-0.9-3.2-2.6-3.2h-2.6V47.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M126.2,40.9v19.3h-3.9V40.9h-4.5v-3.2h12.9v3.2H126.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M145.6,37.7v3.2h-7.7v16.1h7.7v3.2H134V37.7H145.6z M143.6,50.6h-4.4l-1.3-3.2h5.7V50.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M152.7,47.2v13.1h-3.9V37.7h3.9l3.8,9.8l3.8-9.8h3.9v22.6h-3.9V47.2l-3.9,9.9L152.7,47.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M179.1,37.7v3.2h-7.7v16.1h7.7v3.2h-11.6V37.7H179.1z M177.1,50.6h-4.5l-1.3-3.2h5.7L177.1,50.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M186.2,47.2v13.1h-3.9V37.7h3.9l5.1,13.1V37.7h3.9v22.6h-3.9L186.2,47.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M206.8,40.9v19.3h-3.9V40.9h-4.5v-3.2h12.9v3.2H206.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M223.2,57.1v3.2h-3.9V37.7h6.4c4.3,0,6.4,2.1,6.4,6.4v9.7c0,4.3-2.1,6.4-6.4,6.4h-1.3L223.2,57.1z M223.2,57.1 h2.6c1.7,0,2.6-1.1,2.6-3.2v-9.7c0-2.1-0.9-3.2-2.6-3.2h-2.6V57.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M244.5,54.1V37.7h3.9v16.4c0,4.3-2.1,6.4-6.4,6.4s-6.4-2.1-6.4-6.4V37.7h3.9v16.4c0,2.1,0.9,3.2,2.6,3.2 S244.5,56.3,244.5,54.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M260.3,47.4v12.9h-3.9V37.7h6.4c4.3,0,6.4,2.1,6.4,6.4s-2.1,6.4-6.4,6.4h-1.3L260.3,47.4z M260.3,47.4h2.6 c1.7,0,2.6-1.1,2.6-3.2s-0.9-3.2-2.6-3.2h-2.6V47.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M279.2,57.1h-3.8l-0.8-1.9l-1.2,5.1h-3.9l5.2-22.6h3.9l5.2,22.6h-3.9L279.2,57.1z M274.9,53.8h3.5l-1.8-7.7 L274.9,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M298.3,43.8l-3.9,1.6v-1.6c0-2.1-0.9-3.2-2.6-3.2s-2.6,1.1-2.6,3.2c0,1.8,1.5,3.1,4.5,3.9 c3,0.8,4.5,2.9,4.5,6.4c0,4.3-2.1,6.4-6.4,6.4s-6.4-2.1-6.4-6.4l3.9-1.6v1.6c0,2.1,0.9,3.2,2.6,3.2s2.6-1.1,2.6-3.2 c0-1.8-1.5-3.1-4.5-3.9c-3-0.8-4.5-2.9-4.5-6.4c0-4.3,2.1-6.4,6.4-6.4S298.3,39.5,298.3,43.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M310.5,50.6h-9v-3.2h9V50.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M317.6,57.1v3.2h-3.9V37.7h6.4c4.3,0,6.4,2.1,6.4,6.4v9.7c0,4.3-2.1,6.4-6.4,6.4h-1.3L317.6,57.1z M317.6,57.1 h2.6c1.7,0,2.6-1.1,2.6-3.2v-9.7c0-2.1-0.9-3.2-2.6-3.2h-2.6V57.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M341.5,37.7v3.2h-7.7v16.1h7.7v3.2h-11.6V37.7H341.5z M339.5,50.6H335l-1.3-3.2h5.7L339.5,50.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M353.7,50.6h-9v-3.2h9V50.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M369.8,43.8l-3.9,1.6v-1.6c0-2.1-0.9-3.2-2.6-3.2s-2.6,1.1-2.6,3.2v10.3c0,2.1,0.9,3.2,2.6,3.2 s2.6-1.1,2.6-3.2v-1.6l3.9,1.6c0,4.3-2.1,6.4-6.4,6.4s-6.4-2.1-6.4-6.4V43.8c0-4.3,2.1-6.4,6.4-6.4S369.8,39.5,369.8,43.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M381,57.1h-3.8l-0.8-1.9l-1.2,5.1h-3.9l5.2-22.6h3.9l5.2,22.6h-3.9L381,57.1z M376.8,53.8h3.5l-1.8-7.7 L376.8,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M391.9,60.3H388V37.7h3.9V60.3z M399.6,60.3h-6.4l-1.3-3.2h7.7V60.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M411.6,57.1h-3.8l-0.8-1.9l-1.2,5.1H402l5.2-22.6h3.9l5.2,22.6h-3.9L411.6,57.1z M407.4,53.8h3.5l-1.8-7.7 L407.4,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M422.5,60.3h-3.9V37.7h3.9V60.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M438.6,43.8l-3.9,1.6v-1.6c0-2.1-0.9-3.2-2.6-3.2s-2.6,1.1-2.6,3.2c0,1.8,1.5,3.1,4.5,3.9 c3,0.8,4.5,2.9,4.5,6.4c0,4.3-2.1,6.4-6.4,6.4s-6.4-2.1-6.4-6.4l3.9-1.6v1.6c0,2.1,0.9,3.2,2.6,3.2s2.6-1.1,2.6-3.2 c0-1.8-1.5-3.1-4.5-3.9c-3-0.8-4.5-2.9-4.5-6.4c0-4.3,2.1-6.4,6.4-6.4S438.6,39.5,438.6,43.8z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M533,290.7v-16.4h3.9v16.4c0,4.3-2.1,6.4-6.4,6.4s-6.4-2.1-6.4-6.4v-16.4h3.9v16.4c0,2.1,0.9,3.2,2.6,3.2 S533,292.8,533,290.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M544,283.7v13.1h-3.9v-22.6h3.9l5.1,13.1v-13.1h3.9v22.6h-3.9L544,283.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M567.8,274.3v3.2h-7.7v16.1h7.7v3.2h-11.6v-22.6H567.8z M565.8,287.1h-4.4l-1.3-3.2h5.7V287.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M582.3,273.9c4.3,0,6.4,2.1,6.4,6.4v10.3c0,4.3-2.1,6.4-6.4,6.4s-6.4-2.1-6.4-6.4v-10.3 C575.9,276.1,578,273.9,582.3,273.9z M584.9,280.4c0-2.1-0.9-3.2-2.6-3.2s-2.6,1.1-2.6,3.2v10.3c0,2.1,0.9,3.2,2.6,3.2 s2.6-1.1,2.6-3.2V280.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M604.9,280.4L601,282v-1.6c0-2.1-0.9-3.2-2.6-3.2s-2.6,1.1-2.6,3.2v10.3c0,2.1,0.9,3.2,2.6,3.2 s2.6-1.1,2.6-3.2v-1.6l3.9,1.6c0,4.3-2.1,6.4-6.4,6.4s-6.4-2.1-6.4-6.4v-10.3c0-4.3,2.1-6.4,6.4-6.4S604.9,276.1,604.9,280.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M621,280.4l-3.9,1.6v-1.6c0-2.1-0.9-3.2-2.6-3.2s-2.6,1.1-2.6,3.2v10.3c0,2.1,0.9,3.2,2.6,3.2s2.6-1.1,2.6-3.2 v-1.6l3.9,1.6c0,4.3-2.1,6.4-6.4,6.4s-6.4-2.1-6.4-6.4v-10.3c0-4.3,2.1-6.4,6.4-6.4S621,276.1,621,280.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M632.2,293.6h-3.8l-0.8-1.9l-1.2,5.1h-3.9l5.2-22.6h3.9l5.2,22.6h-3.9L632.2,293.6z M627.9,290.4h3.5l-1.8-7.7 L627.9,290.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M651.3,280.4l-3.9,1.6v-1.6c0-2.1-0.9-3.2-2.6-3.2s-2.6,1.1-2.6,3.2c0,1.8,1.5,3.1,4.5,3.9 c3,0.8,4.5,2.9,4.5,6.4c0,4.3-2.1,6.4-6.4,6.4s-6.4-2.1-6.4-6.4l3.9-1.6v1.6c0,2.1,0.9,3.2,2.6,3.2s2.6-1.1,2.6-3.2 c0-1.8-1.5-3.1-4.5-3.9c-3-0.8-4.5-2.9-4.5-6.4c0-4.3,2.1-6.4,6.4-6.4S651.3,276.1,651.3,280.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M658.4,296.8h-3.9v-22.6h3.9V296.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M668,273.9c4.3,0,6.4,2.1,6.4,6.4v10.3c0,4.3-2.1,6.4-6.4,6.4s-6.4-2.1-6.4-6.4v-10.3 C661.6,276.1,663.7,273.9,668,273.9z M670.6,280.4c0-2.1-0.9-3.2-2.6-3.2s-2.6,1.1-2.6,3.2v10.3c0,2.1,0.9,3.2,2.6,3.2 s2.6-1.1,2.6-3.2V280.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M681.6,283.7v13.1h-3.9v-22.6h3.9l5.1,13.1v-13.1h3.9v22.6h-3.9L681.6,283.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M702.5,283.9v12.9h-3.9v-22.6h6.4c4.3,0,6.4,2.1,6.4,6.4s-2.1,6.4-6.4,6.4h-1.3L702.5,283.9z M702.5,283.9h2.6 c1.7,0,2.6-1.1,2.6-3.2s-0.9-3.2-2.6-3.2h-2.6V283.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M721.2,273.9c4.3,0,6.4,2.1,6.4,6.4v10.3c0,4.3-2.1,6.4-6.4,6.4s-6.4-2.1-6.4-6.4v-10.3 C714.8,276.1,716.9,273.9,721.2,273.9z M723.8,280.4c0-2.1-0.9-3.2-2.6-3.2s-2.6,1.1-2.6,3.2v10.3c0,2.1,0.9,3.2,2.6,3.2 s2.6-1.1,2.6-3.2V280.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M739.9,290.7v-16.4h3.9v16.4c0,4.3-2.1,6.4-6.4,6.4s-6.4-2.1-6.4-6.4v-16.4h3.9v16.4c0,2.1,0.9,3.2,2.6,3.2 S739.9,292.8,739.9,290.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M750.9,283.9v12.9H747v-22.6h6.4c4.3,0,6.4,2.1,6.4,6.4c0,2.1-0.5,3.8-1.6,4.8c1.1,1.1,1.6,2.7,1.6,4.8v6.4 H756v-6.4c0-2.1-0.9-3.2-2.6-3.2h-1.3L750.9,283.9z M750.9,283.9h2.6c1.7,0,2.6-1.1,2.6-3.2s-0.9-3.2-2.6-3.2h-2.6V283.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M771.8,296.8h-3.9v-22.6h3.9V296.8z M779.5,296.8h-6.4l-1.3-3.2h7.7V296.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M786.6,282.3h-3.9v-8.1h3.9V282.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M798.6,293.6h-3.8l-0.8-1.9l-1.2,5.1H789l5.2-22.6h3.9l5.2,22.6h-3.9L798.6,293.6z M794.4,290.4h3.5l-1.8-7.7 L794.4,290.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M814.7,290.7v-16.4h3.9v16.4c0,4.3-2.1,6.4-6.4,6.4s-6.4-2.1-6.4-6.4v-16.4h3.9v16.4c0,2.1,0.9,3.2,2.6,3.2 S814.7,292.8,814.7,290.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M830.1,277.5v19.3h-3.9v-19.3h-4.5v-3.2h12.9v3.2H830.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M842.7,273.9c4.3,0,6.4,2.1,6.4,6.4v10.3c0,4.3-2.1,6.4-6.4,6.4s-6.4-2.1-6.4-6.4v-10.3 C836.3,276.1,838.4,273.9,842.7,273.9z M845.3,280.4c0-2.1-0.9-3.2-2.6-3.2s-2.6,1.1-2.6,3.2v10.3c0,2.1,0.9,3.2,2.6,3.2 s2.6-1.1,2.6-3.2V280.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M856.2,283.7v13.1h-3.9v-22.6h3.9l5.1,13.1v-13.1h3.9v22.6h-3.9L856.2,283.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M874.9,273.9c4.3,0,6.4,2.1,6.4,6.4v10.3c0,4.3-2.1,6.4-6.4,6.4s-6.4-2.1-6.4-6.4v-10.3 C868.5,276.1,870.6,273.9,874.9,273.9z M877.5,280.4c0-2.1-0.9-3.2-2.6-3.2s-2.6,1.1-2.6,3.2v10.3c0,2.1,0.9,3.2,2.6,3.2 s2.6-1.1,2.6-3.2V280.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M888.5,283.7v13.1h-3.9v-22.6h3.9l3.8,9.8l3.8-9.8h3.9v22.6h-3.9v-13.1l-3.9,9.9L888.5,283.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M907.2,296.8h-3.9v-22.6h3.9V296.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M922,274.3v3.2h-7.7v16.1h7.7v3.2h-11.6v-22.6H922z M920,287.1h-4.5l-1.3-3.2h5.8V287.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAidotec);
export default __webpack_public_path__ + "static/media/logo-aidotec.a3c57c3c99bc98369c3ec8a2d3b882d3.svg";
export { ForwardRef as ReactComponent };